// extracted by mini-css-extract-plugin
export default {"link":"container-link_link__Ayini"};